import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DriverService } from 'src/app/services/driver.service';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { MatRadioModule } from '@angular/material/radio';
import { ArchwizardModule } from 'angular-archwizard';
import { DirectivesModule } from 'src/app/views/layout/directives/directives.module';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DateTimeAdapter, OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectFilterModule } from 'mat-select-filter';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ManufacturerComponent } from './manufacturer.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MomentDateTimeAdapter } from 'ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time-adapter.class';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { BookingService } from 'src/app/services/booking.service';
import { ManufacturerUpdatePopupComponent } from './manufacturerupdatepopup/manufacturerupdatepopup.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import { MatCheckboxModule } from '@angular/material/checkbox';
export const MY_FORMATS = {
  parseInput: 'DD/MM/YYYY',
  fullPickerInput: 'DD/MM/YYYY hh:mm a',
  datePickerInput: 'DD/MM/YYYY',
  timePickerInput: 'hh:mm a',
  monthYearLabel: 'MMM-YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM-YYYY'
}
const routes: Routes = [
  {
    path: ':id/:actionInfo',
    component: ManufacturerComponent
  },
  {
    path: '',
    component: ManufacturerComponent
  }
]

@NgModule({
  declarations: [ManufacturerComponent , ManufacturerUpdatePopupComponent],
  providers: [DriverService,CashBookingService, BookingService,
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} },
    {provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE]},
    {provide: OWL_DATE_TIME_FORMATS, useValue: MY_FORMATS},
    {provide: OWL_DATE_TIME_LOCALE, useValue: 'ist'},
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: false } }],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatDialogModule,
    NgbModule,
    ArchwizardModule,
    RouterModule.forChild(routes),
    DirectivesModule,   
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSelectModule, 
    MatSelectFilterModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatButtonModule,
    MatIconModule,
    NgbDropdownModule,
    NgMultiSelectDropDownModule.forRoot(),
    MatRadioModule,
    ArchwizardModule,
    DirectivesModule,
    HttpClientModule,
    MatTabsModule,
    MatTreeModule,
    MatCheckboxModule
  ],
  exports: [ManufacturerComponent]
})
export class ManufacturerModule { }
